import React, { useState, useRef } from 'react';

const Login = ({ onLogin }) => {
  const [form, setForm] = useState({ korisnicko_ime: '', lozinka: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showPassword, setShowPassword] = useState(false);
  const loginButtonRef = useRef(null);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setError('');

    try {
      const response = await fetch(`${process.env.REACT_APP_API_URL || 'https://172-104-157-116.ip.linodeusercontent.com'}/api/auth/login`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          korisnicko_ime: form.korisnicko_ime,
          lozinka: form.lozinka
        })
      });

      // Check if response is JSON
      const contentType = response.headers.get('content-type');
      if (!contentType || !contentType.includes('application/json')) {
        const text = await response.text();
        console.error('Non-JSON response:', text);
        setError(`Server error: Expected JSON but got ${contentType || 'unknown content type'}`);
        return;
      }

      const data = await response.json();

      if (data.success) {
        // Store token in localStorage for web
        console.log('Login successful, storing token:', data.token ? 'Token received' : 'No token');
        console.log('Token length:', data.token ? data.token.length : 0);
        localStorage.setItem('auth_token', data.token);
        localStorage.setItem('user_data', JSON.stringify({
          zaposlenik_id: data.user.zaposlenik_id,
          korisnicko_ime: data.user.korisnicko_ime,
          ime: data.user.ime,
          prezime: data.user.prezime
        }));
        console.log('Token stored in localStorage:', localStorage.getItem('auth_token') ? 'Success' : 'Failed');
        onLogin({
          zaposlenik_id: data.user.zaposlenik_id,
          korisnicko_ime: data.user.korisnicko_ime,
          ime: data.user.ime,
          prezime: data.user.prezime
        });
      } else {
        setError(data.message || data.error || 'Login failed');
      }
    } catch (err) {
      console.error('Login error:', err);
      setError(`Connection error: ${err.message}. Check console for details.`);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      background: 'linear-gradient(135deg, #CAE0BC 0%, #EAFAEA 100%)',
      fontFamily: 'Arial, sans-serif'
    }}>
      <div id="loginCard" style={{
        background: 'white',
        padding: '40px',
        borderRadius: '20px',
        boxShadow: '0 20px 40px rgba(0,0,0,0.1)',
        width: '100%',
        maxWidth: '400px',
        boxSizing: 'border-box'
      }}>
        <style>{`
          #loginCard, #loginCard * , #loginCard *::before, #loginCard *::after {
            box-sizing: border-box !important;
          }
        `}</style>
        <div style={{ textAlign: 'center', marginBottom: '30px' }}>
          <div style={{ 
            marginBottom: '10px',
            width: '120px',
            height: '120px',
            borderRadius: '12px',
            backgroundColor: 'rgba(108, 139, 88, 0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            margin: '0 auto 20px',
            overflow: 'hidden',
            boxShadow: '0 4px 12px rgba(108, 139, 88, 0.2)'
          }}>
            <img 
              src="/zzf.png" 
              alt="ZZF Logo" 
              style={{
                width: '100px',
                height: '100px',
                objectFit: 'contain'
              }}
            />
          </div>
          <h1 style={{ 
            margin: 0, 
            fontSize: '2rem',
            background: 'linear-gradient(135deg, #6C8B58, #8BA888)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
            fontWeight: 'bold'
          }}>ZZF</h1>
        </div>

        <form onSubmit={handleSubmit} style={{ boxSizing: 'border-box', width: '100%' }}>
          {error && (
            <div style={{
              background: '#fee',
              color: '#c33',
              padding: '12px',
              borderRadius: '8px',
              marginBottom: '20px',
              border: '1px solid #fcc'
            }}>
              {error}
            </div>
          )}

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
              Korisničko ime
            </label>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              border: '2px solid #e1e5e9',
              borderRadius: '12px',
              backgroundColor: '#f8f9fa',
              padding: '0 15px',
              width: '100%',
              boxSizing: 'border-box'
            }}>
              <span style={{ color: '#6C8B58', marginRight: '10px' }}>👤</span>
              <input
                type="text"
                value={form.korisnicko_ime}
                onChange={(e) => setForm({...form, korisnicko_ime: e.target.value})}
                style={{
                  flex: 1,
                  padding: '15px 0',
                  border: 'none',
                  outline: 'none',
                  fontSize: '1rem',
                  backgroundColor: 'transparent'
                }}
                placeholder="Unesite korisničko ime"
                required
                disabled={loading}
              />
            </div>
          </div>

          <div style={{ marginBottom: '20px' }}>
            <label style={{ display: 'block', marginBottom: '8px', fontWeight: 'bold', color: '#333' }}>
              Lozinka
            </label>
            <div style={{
              display: 'flex',
              alignItems: 'center',
              border: '2px solid #e1e5e9',
              borderRadius: '12px',
              backgroundColor: '#f8f9fa',
              padding: '0 15px',
              width: '100%',
              boxSizing: 'border-box'
            }}>
              <span style={{ color: '#6C8B58', marginRight: '10px' }}>🔒</span>
              <input
                type={showPassword ? 'text' : 'password'}
                value={form.lozinka}
                onChange={(e) => setForm({...form, lozinka: e.target.value})}
                onKeyDown={(e) => {
                  if (e.key === 'Tab' && form.lozinka.trim() !== '') {
                    e.preventDefault();
                    loginButtonRef.current?.focus();
                  }
                }}
                style={{
                  flex: 1,
                  padding: '15px 0',
                  border: 'none',
                  outline: 'none',
                  fontSize: '1rem',
                  backgroundColor: 'transparent'
                }}
                placeholder="Unesite lozinku"
                required
                disabled={loading}
              />
              <button
                type="button"
                onClick={() => setShowPassword(!showPassword)}
                style={{
                  background: 'none',
                  border: 'none',
                  cursor: 'pointer',
                  color: '#6C8B58',
                  padding: '5px'
                }}
                disabled={loading}
              >
                {showPassword ? '🙈' : '👁️'}
              </button>
            </div>
          </div>

          <div style={{
            display: 'flex',
            alignItems: 'center',
            border: '2px solid #e1e5e9',
            borderRadius: '12px',
            backgroundColor: '#6C8B58',
            padding: '0 15px',
            width: '100%',
            boxSizing: 'border-box'
          }}>
            <button
              ref={loginButtonRef}
              type="submit"
              disabled={loading}
              style={{
                width: '100%',
                padding: '15px 0',
                background: 'transparent',
                color: 'white',
                border: 'none',
                borderRadius: '10px',
                fontSize: '1rem',
                fontWeight: 'bold',
                cursor: loading ? 'not-allowed' : 'pointer',
                opacity: loading ? 0.7 : 1,
                boxShadow: 'none',
                transition: 'all 0.3s ease',
                display: 'block'
              }}
              onMouseOver={(e) => {
                if (!loading) {
                  e.target.style.transform = 'translateY(-2px)';
                }
              }}
              onMouseOut={(e) => {
                if (!loading) {
                  e.target.style.transform = 'translateY(0)';
                }
              }}
            >
              {loading ? 'Prijavljivanje...' : 'Prijavite se'}
            </button>
          </div>
        </form>

        <div style={{ textAlign: 'center', marginTop: '30px' }}>
          <p style={{ color: 'rgba(108, 139, 88, 0.7)', fontSize: '12px', margin: 0 }}>
            © 2025 ZZF - Zavod za fotogrametriju d.d.
          </p>
        </div>
      </div>
    </div>
  );
};

export default Login;